// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  circleContainer: {
    position: 'absolute',
    right: 0,
    top: -15,
    backgroundColor: GlobalStyles.color.COLOR_SECONDARY,
    borderRadius: 10,
    padding: '2px 5px',
  },

  circleText: {
    margin: 0,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_MONTSERRAT_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  }
});

export default styles;
